import { faTimes } from '@fortawesome/free-solid-svg-icons'
import React, { FunctionComponent } from 'react'

import { IProps } from './IProps'
import {
  BackgroundBlur,
  ModalCloseIcon,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from './style'

const Modal: FunctionComponent<IProps> = ({
  children,
  modalState,
  setModalState,
  modalTitle,
  extraWidth,
  enableOverflow,
  modalContainerStyle,
  contentContainerStyle,
}) => {
  const renderTitle = modalTitle ? <ModalTitle>{modalTitle}</ModalTitle> : null

  const closeModal = () => {
    setModalState(false)
  }

  return modalState ? (
    <ModalRoot>
      <ModalContainer
        extraWidth={extraWidth}
        enableOverflow={enableOverflow}
        style={modalContainerStyle}>
        <ModalHeader>
          {renderTitle}
          <ModalCloseIcon
            icon={faTimes}
            color={'#2164db'}
            onClick={closeModal}
          />
        </ModalHeader>
        <ModalContent style={contentContainerStyle}>{children}</ModalContent>
      </ModalContainer>
      <BackgroundBlur onClick={closeModal} />
    </ModalRoot>
  ) : null
}

export default Modal
